import { useCallback, useState } from 'react';

// https://usehooks.com/useLocalStorage/

const useLocalStorage = (key, initialValue, forceInitialValue = false) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      let item = null;
      // Get from local storage by key
      if (process.browser) {
        // Disable access to localStorage if it's not browser as
        // SSR doesn't have access to browser window
        item = window.localStorage.getItem(key);
      }
      // Parse stored json or if none return initialValue
      if (forceInitialValue) {
        return initialValue;
      }
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.error(error);
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = useCallback(
    value => {
      try {
        // Keep setter identity stable and support functional updates safely.
        setStoredValue(prevStoredValue => {
          const valueToStore = value instanceof Function ? value(prevStoredValue) : value;

          if (process.browser) {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
          }

          return valueToStore;
        });
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.error(error);
      }
    },
    [key]
  );

  return [storedValue, setValue];
};

export default useLocalStorage;
